module.exports = __webpack_public_path__ + "static/media/lacruz.87774bb4.png";